/**
 * Simple delay for use in promise/async flow. Like "sleep".
 * @param {Number} millis - Milliseconds of time to wait.
 * @return {Promise<void>} A promise that waits the specified milliseconds.
 */
export default millis => new Promise(resolve => setTimeout(() => resolve(), millis))
